import { H5, Text } from 'platform-components/common';
import { HEADER_TEXT_SIZE } from 'platform-components/constants';
import React from 'react';

import './spec-course-lesson-view__rules-block.scss';

interface Props {
    description: string;
    blockIndex: number;
    title: string;
}

export const SpecCourseLessonViewRulesBlock = ({ description, blockIndex, title }: Props) => {
    return (
        <div className="spec-course-lesson-view__rules-block">
            <div className="spec-course-lesson-view__rules-block_count">
                <Text size={Text.SIZE.XL} weight={Text.WEIGHT.M}>
                    {blockIndex}
                </Text>
            </div>
            <div className="spec-course-lesson-view__rules-block_title">
                <H5 size={HEADER_TEXT_SIZE.XS} weight={Text.WEIGHT.M}>
                    {title}
                </H5>
            </div>
            <div className="spec-course-lesson-view__rules-block_description">
                <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN}>
                    {description}
                </Text>
            </div>
        </div>
    );
};
